/* unplugin-vue-components disabled */
import TrackerSegment from './tracker-segment.vue'
import TrackerSlider from './tracker-slider.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerTextarea from './tracker-textarea.vue'
import RolesSelector from './roles-selector.vue'
import {markRaw} from 'vue'
import {sliderFocus} from '../pulse-defs'
import $contacts2, {$contacts_groups} from 'stores/contacts2'
import $companies from 'stores/companies'
import CompanyTile from '../company-tile.vue'
import {PERSON_ALERTS} from 'consts/tracker'
import {CompanySearch, ContactSearch} from 'components/search-dropdown'

export default {
  components: {CompanyTile, CompanySearch, TrackerSegment, ContactSearch, TrackerSlider, TrackerButtongroup, TrackerTextarea, RolesSelector},
  props: {
    companyId: {
      type: String,
      default: undefined
    }
  },
  emits: ['cancel'],
  data() {
    return {
      company: undefined,
      saving: false,
      alerts: markRaw(PERSON_ALERTS),

      contact: undefined,
      tracker_roles: [],
      tracker_alerts: 'all',
      tracker_focus: 'balanced',
      focus_on: '',
      chosen_company: undefined,
      valid: true,
    }
  },
  computed: {
    company_name(){
      return this.company?.name || this.chosen_company?.name
    },
    loading(){
      if (this.companyId) {
        return !this.company
      }
      return false
    },
    can_save() {
      if (this.company) {
        return this.valid && !!this.tracker_data.linkedin_id
      }
      return !!this.chosen_company && this.valid && !!this.tracker_data.linkedin_id
    },
    tracker_data(){
      return  {
        linkedin_id: this.contact?.linkedin_id,
        tracker_focus: this.tracker_focus,
        tracker_alerts: this.tracker_alerts,
        tracker_roles: this.tracker_roles,
        focus_on: this.focus_on,
        shared_company_id: this.chosen_company?.shared_company_id || this.shared_company_id,
        company_linkedin_id: this.chosen_company?.linkedin_id,
        company_name: this.chosen_company?.name,
      }
    },
    slider_focus: sliderFocus(),
    focus_text() {
      return !!this.focus_on?.trim()
    }
  },
  watch: {
    chosen_company() {
      const linkedin_only =  this.contact?.linkedin_id && Object.keys(this.contact).length === 1
      if (linkedin_only) return
      this.$refs.linkedin.clear()
    }
  },
  mounted() {
    this.$debounce_175(this.init)
  },
  methods: {
    async init() {
      if (this.companyId) {
        this.company = await $companies.loadCompany(this.companyId)
        this.shared_company_id = this.company.shared_company_id
        await this.$nextTick()
        this.$refs.linkedin.focus()
      }
      else this.$refs.company.focus()
    },
    async onSave() {
      this.saving = true
      try {
        const contact = await $contacts2.newContact(this.tracker_data)
        $contacts_groups.addContact(contact.state_copy)
        this.$dispatch('edit-company', {company_id: contact.user_company_id})
      } catch (err) {
        if (!err.http_code) throw err
        if (err.http_code === 409) {
          const msg = err.json?.first_name ? `<b>${err.json.first_name} ${err.json.last_name}</b>` : 'this person'
          $utils.toasts.success(`You are already tracking <b>${msg}</b>.`)
          return
        }
        if (err.http_code === 461) {
          $utils.toasts.error('It seems that this person does not exist. Please try again.')
          return
        }
        $utils.toasts.error(`Failed to follow person: ${err}`)
      }
      finally {
        this.saving = false
        this.$dispatch('save', this.tracker_data)
      }
    }
  }
}
